/**
 * 引き出しの「声の聞き比べ」（ADR-0064）の中身。DOM を持たない部分（テストできるように分ける）。
 * 何を出すかは Gateway が返した値（GET /v1/voice-ab/next）だけで決める。どちらがどの声かは画面に出ない（Gateway も返さない）。
 * 鳴らした回数は記録として答えに添えるだけ。聞いていなくても答えは断らない（決めるのは聞く人）。
 */
export type VoiceAbChoice = "a" | "b" | "same";

export interface VoiceAbView {
  trial: { trial_id: string; sentence: string } | null;
  pending: number;
  frozen?: boolean;
}

/** 選ぶボタン（並びは画面の左から） */
export const VOICE_AB_CHOICES: { choice: VoiceAbChoice; label: string }[] = [
  { choice: "a", label: "A がよい" },
  { choice: "same", label: "同じ" },
  { choice: "b", label: "B がよい" },
];

/** 一言の上限（packages/contracts の VOICE_AB_COMMENT_MAX と同じ） */
export const VOICE_AB_COMMENT_MAX = 500;

export interface VoiceAbCardModel {
  show: boolean;
  sentence: string;
  /** 「残り 3 件」（この 1 件を含む） */
  remaining: string;
}

export function voiceAbCardModel(v: VoiceAbView | null): VoiceAbCardModel {
  if (!v?.trial) return { show: false, sentence: "", remaining: "" };
  return {
    show: true,
    sentence: v.trial.sentence,
    remaining: v.pending > 1 ? `残り ${v.pending} 件` : "これが最後の 1 件",
  };
}

/** 答えの本文（POST /v1/voice-ab/answer）。一言は前後の空白を除き、空なら付けない */
export function voiceAbAnswerBody(
  trial_id: string,
  choice: VoiceAbChoice,
  comment: string,
  plays: { a: number; b: number },
) {
  const c = comment.trim().slice(0, VOICE_AB_COMMENT_MAX);
  return { trial_id, choice, ...(c ? { comment: c } : {}), plays: { ...plays } };
}

/** 答えの失敗の文 */
export function voiceAbErrorText(code: string): string {
  const m: Record<string, string> = {
    frozen: "今は止まっています（凍結中）。答えは書けません。",
    already_answered: "この 1 件は、もう答えが入っています。",
    not_found: "この 1 件は見つかりませんでした（外されたかもしれません）。",
    passkey_session_required: "この端末からは答えられません。",
    audio_missing: "音が見つかりませんでした。",
    audio_mismatch: "音が作ったときと違うので鳴らしません。",
  };
  return m[code] ?? `うまくいきませんでした（${code}）`;
}
